import React, { useEffect, useRef, useState } from "react";
import { Smile } from "lucide-react";

// 32 most-used emojis for welder community — clear, neutral, work-friendly
const EMOJIS = [
  "👍", "🔥", "💯", "✅", "❌", "⚠️", "🙏", "👀",
  "😂", "😎", "🤝", "💪", "🛠️", "🔧", "⚒️", "🔨",
  "❤️", "🎯", "👏", "🤔", "😅", "👨‍🏭", "👷", "🚀",
  "🇸🇰", "🇨🇿", "🇩🇪", "🇵🇱", "📍", "💬", "✨", "🎉",
];

/**
 * Floating emoji picker. Props:
 *  - onPick(emoji) — callback when user clicks an emoji
 *  - testid — base data-testid (default "emoji")
 */
export default function EmojiPicker({ onPick, testid = "emoji" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        onClick={() => setOpen(!open)}
        aria-label="Pridať emoji"
        title="Pridať emoji"
        className="p-2 text-zinc-400 hover:text-gold-400 transition-colors"
      >
        <Smile className="w-5 h-5" />
      </button>
      {open && (
        <div
          data-testid={`${testid}-panel`}
          className="absolute bottom-12 right-0 z-50 grid grid-cols-8 gap-1 p-2 bg-zinc-950 border border-gold-700/40 shadow-[0_8px_30px_-5px_rgba(0,0,0,0.8)] w-[280px]"
        >
          {EMOJIS.map((e) => (
            <button
              key={e}
              type="button"
              data-testid={`${testid}-${e}`}
              onClick={() => { onPick(e); setOpen(false); }}
              className="text-2xl hover:bg-zinc-800 rounded transition-colors p-0.5"
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
